import { CaseListPage } from "@/features/case/pages/CaseListPage";

export const CaseList = () => {
  return <CaseListPage />;
};
